import React, { useEffect, useState } from "react";
import { adminCreateSlider, adminDeleteSlider, adminGetSliders } from "../services/api";
import AdminLayout from "./AdminLayout";
import { getImageUrl } from "../utils/imageHelper";

export default function AdminSliders() {
  const [sliders, setSliders] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [link, setLink] = useState("");
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      const data = await adminGetSliders();
      setSliders(data);
    } catch (err) {
      console.error("Failed to load sliders", err);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!image) {
      alert("Gambar slider harus diunggah");
      return;
    }
    
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("title", title);
      fd.append("description", description);
      fd.append("link", link);
      fd.append("image", image);
      fd.append("is_active", 1);

      await adminCreateSlider(fd);
      setTitle("");
      setDescription("");
      setLink("");
      setImage(null);
      await load();
      alert("Slider berhasil dibuat");
    } catch (err) {
      alert("Gagal membuat slider. Pastikan Anda memiliki akses admin.");
    } finally {
      setLoading(false);
    }
  };

  const del = async (id) => {
    if (!window.confirm("Apakah Anda yakin ingin menghapus slider ini?")) return;
    try {
      await adminDeleteSlider(id);
      await load();
    } catch (err) {
      alert("Gagal menghapus slider.");
    }
  };

  return (
    <AdminLayout>
      <div className="section-header" style={{ textAlign: 'left', margin: '0 0 30px' }}>
        <h2 className="section-title">Manajemen Slider</h2>
      </div>

      <div className="auth-card" style={{ maxWidth: '100%', margin: '0 0 40px' }}>
        <h3 style={{ marginBottom: '20px' }}>Tambah Slider Baru</h3>
        <form onSubmit={create}>
          <div className="admin-form-grid-2" style={{ gap: '20px' }}>
            <div className="form-group">
              <label className="form-label">Judul</label>
              <input 
                className="form-input" 
                value={title} 
                onChange={(e) => setTitle(e.target.value)} 
                required 
                placeholder="Contoh: Kesenian Otentik Bali"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Link (Opsional)</label>
              <input 
                className="form-input" 
                value={link} 
                onChange={(e) => setLink(e.target.value)} 
                placeholder="/products"
              />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Deskripsi</label>
            <textarea 
              className="form-input" 
              rows="3"
              value={description} 
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Jelaskan tentang slider ini..."
            />
          </div>
          <div className="form-group">
            <label className="form-label">Gambar Slider</label>
            <input 
              type="file" 
              className="form-input"
              onChange={(e) => setImage(e.target.files?.[0] || null)} 
              accept="image/*"
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Menyimpan..." : "Tambah Slider"}
          </button>
        </form>
      </div>

      <h3 style={{ marginBottom: '20px' }}>Daftar Slider</h3>
      <table className="admin-table">
        <thead>
          <tr>
            <th>Gambar</th>
            <th>Info Slider</th>
            <th>Link</th>
            <th>Status</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {sliders.map((s) => (
            <tr key={s.id}>
              <td style={{ width: '150px' }}>
                <img 
                  src={getImageUrl(s.image, 'https://via.placeholder.com/120x70?text=No+Image')} 
                  alt={s.title} 
                  style={{ width: '120px', height: '70px', objectFit: 'cover', borderRadius: '8px' }}
                />
              </td>
              <td>
                <div style={{ fontWeight: 700 }}>{s.title}</div>
                <div style={{ fontSize: '0.85rem', color: '#666' }}>{s.description}</div>
              </td>
              <td><code>{s.link || "-"}</code></td>
              <td>
                <span style={{ 
                  padding: '4px 12px', 
                  background: s.is_active ? '#E8F5E9' : '#FFEBEE', 
                  color: s.is_active ? '#2E7D32' : '#C62828',
                  borderRadius: '20px',
                  fontSize: '0.8rem',
                  fontWeight: 600
                }}>
                  {s.is_active ? "Aktif" : "Non-aktif"}
                </span>
              </td>
              <td>
                <button onClick={() => del(s.id)} style={{ color: 'red', fontWeight: 600 }}>Hapus</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminLayout>
  );
}
